import { PerformanceLogPolicy } from "./PerformanceLogPolicy";

export class PerformanceLogPolicyFactory {
  private readonly policy = new PerformanceLogPolicy();

  create(): PerformanceLogPolicy {
    return this.policy;
  }
}

export const performanceLogPolicyFactory = new PerformanceLogPolicyFactory();
